
<script>

  import func from "../../libs/functions.js";

  import {
    mapGetters,
    mapActions
  } from "vuex";


   import iziToast from 'izitoast'
   import 'izitoast/dist/css/iziToast.min.css';
  
  import _ from "lodash";

  import _system from '../../libs/system';

export default {
   name: "CreateTag",
   data() {
      return {
         color: '',
         loading: {
            create: false
         },
         tag: ''
      }
   },
   computed: {
   ...mapGetters('workspaces', ['workspaces', 'currentWorkspace']),
   ...mapGetters('session', ['isLoggedIn', 'getUser']),
   ...mapGetters('tags', ['tags', 'tagsByName', 'tagsById'])
   },
   methods: {
   ...mapActions("htmlModals", ["setCreateTag"]),
   ...mapActions('tags', ['setTags', 'setPushTag']),
   ...mapActions('workspaces', ['setWorkspaces', 'pushWorkspace', 'setCurrentWorkspace']),
   ...mapActions('workspaceusers', ['setWorkspaceusers']),
   ...mapActions("loading", ["setLoadingApp", "setLoadingAppReRender"]),   
      create(){

         this.loading.create = true;

         if(!this.tag){
            return alert('Cannot be empty');
         }

         let clarifiedNewTag = this.tag.toLowerCase()
         clarifiedNewTag = clarifiedNewTag.charAt(0).toUpperCase() + clarifiedNewTag.slice(1);

         let payload = {
            body: {
               name: clarifiedNewTag,
               typeName: "MessageTag"
            }
         }

         _system.services.tags.create( payload, (err, newTag) => {
            if(err) return alert('Try again later!')

            let payload = {
               body: {
                  userTagId : newTag._id,
                  color: this.color
               },
               query: {
                  workspaceId: this.currentWorkspace._id
               }
            }

            _system.services.tags.addTagIntoCurrentWorkspace( payload, (err, newWorkspace) => {
               if(err) return alert('Try again later!');

                        this.setPushTag(newTag);
                        this.currentWorkspace.userTags = newWorkspace.userTags

                        iziToast.success({
                           title: 'Tag Created'
                        });

                        this.tag = ""

                        this.loading.create = false;

            });

         });


      }
   },
   created(){
      this.color = 'rgb(221, 221, 221)'
   },
   mounted(){
      document.body.addEventListener('keyup', e => { if (e.keyCode === 27) { this.setCreateTag(false) } })
      document.getElementById("searchBox").focus();

      var parent = document.querySelector('#parent');

      var picker = new window.Picker({
      parent: parent,
      color: 'rgb(221, 221, 221)',
      popup: 'right',
      editorFormat: 'hex'
      });

      // You can do what you want with the chosen color using two callbacks: onChange and onDone.
      picker.onChange = (color) => {
            this.color = color.hex
            console.log(this.color)
      };

   }
}

</script>

<template>


<div class="modalWrapper">
<div  @click="setCreateTag(false)" class="modal"> </div>
   <div class="ui grid">
      <div style="margin-top: 10%;" class="ten wide column centered">
            <div style="padding: 0; z-index:9999999;" class="ui basic segment right aligned">
               <a style="background: rgba(0,0,0,0.6);" @click="setCreateTag(false)" class="ui black mini button">Close [ESC]</a>
            </div>
            <div style="z-index:9999999;" class="ui segment shadow">
               <div class="ui action big input fluid">
                  <button style="background: transparent; border: none;color: #bbb;"><i class="tags icon"></i></button>
                  <input id="searchBox" v-model="tag" v-on:keyup.enter="create()" style="border:none; padding-left: 5px;" type="text" placeholder="Lead / Churn / Influencer">
                  <button style="border-radius: 5px;" @click="create();" :class="{ loading: (loading.create) ? true : false }" class="ui blue button">CREATE TAG</button>
               </div>
               <div v-show="tag.length" class="ui divider"></div>
               <div v-show="tag.length" style="margin: -1rem;" class="ui basic segment">
                  <p><b>Color selection:</b> Light colors work best.</p>
                  <div id="parent">
                        <div style="width: 100%; height: 40px;border-radius: 0.3rem; cursor:pointer;" :style="{'background': color}">
                           <span style=" font-weight: bold; color: rgba(0,0,0, .3); text-align: center; display: block; padding-top:10px;">Click here to select color</span>
                        </div>
                      </div>
               </div>
               <div v-show="tag.length" style="margin: 1rem -1rem -1rem -1rem; background: #f5f5f5; border-radius: 0 0 1rem 1rem;" class="ui basic segment">
                  <h4>Preview</h4>
                  <div :style="{'background': color }" class="ui label">{{ tag }}</div>
               </div>
            </div>
      </div>
   </div>
</div>


</template>


<style scoped>
.modalWrapper {
   position: fixed; 
   top: 0; 
   right: 0; 
   bottom: 0; 
   left:0; 
   z-index: 999999; 
   overflow: hidden;
}
.modal {
   position: fixed; 
   top: 0; 
   right: 0; 
   bottom: 0; 
   left:0; 
   background: rgba(15, 17, 26, 0.35) none repeat scroll 0% 0%; 
   z-index: 999999; 
   overflow: hidden;
}

.shadow{
   box-shadow: 0px 0px 44px rgba(99, 99, 99, 0.85);
   border: none;
}
</style>





// WEBPACK FOOTER //
// src/components/dashboard/CreateTag.vue